import { motion } from "framer-motion";
import { ArrowRight, TrendingDown, TrendingUp } from "lucide-react";

export const BeforeAfterComparison = ({ items }) => {
  if (!items || items.length === 0) return null;

  return (
    <div className="space-y-4" data-testid="before-after-section">
      {items.map((item, index) => (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="rounded-xl border border-slate-200 overflow-hidden"
        >
          {/* Aspect Header */}
          <div className="bg-slate-50 px-4 py-3 border-b border-slate-200">
            <h4 className="font-semibold text-slate-900">{item.aspect}</h4>
          </div>
          
          {/* Before/After Columns */}
          <div className="grid grid-cols-1 md:grid-cols-2">
            {/* Before */}
            <div className="p-4 bg-red-50/50 border-b md:border-b-0 md:border-r border-slate-200">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-6 h-6 rounded-full bg-red-100 flex items-center justify-center">
                  <TrendingDown className="w-3.5 h-3.5 text-red-600" />
                </div>
                <span className="text-sm font-medium text-red-700">Before</span>
              </div>
              <p className="text-slate-700 text-sm">{item.before}</p>
            </div>
            
            {/* After */}
            <div className="p-4 bg-emerald-50/50">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center">
                  <TrendingUp className="w-3.5 h-3.5 text-emerald-600" />
                </div>
                <span className="text-sm font-medium text-emerald-700">After</span>
              </div>
              <p className="text-slate-700 text-sm">{item.after}</p>
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};
